import React from 'react';

/** Apply **bold** after HTML escape (safe — no raw tags from model). */
function applyBold(escapedLine) {
  return escapedLine.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
}

/** Escape HTML entities, then apply minimal safe markdown (bold, lists, line breaks). */
export function formatSafeChatText(raw) {
  let text = raw == null ? '' : String(raw);
  // Legacy mock screens use <br>/<strong> — normalize to markdown before escape
  text = text
    .replace(/\r\n/g, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<strong>(.*?)<\/strong>/gi, '**$1**');
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const lines = escaped.split('\n');
  const html = lines
    .map((line) => {
      const trimmed = line.trim();
      if (!trimmed) return '';
      if (/^[-*•]\s+/.test(trimmed)) {
        return `<li>${applyBold(trimmed.replace(/^[-*•]\s+/, ''))}</li>`;
      }
      if (/^\d+[.)、]\s+/.test(trimmed)) {
        return `<li>${applyBold(trimmed.replace(/^\d+[.)、]\s+/, ''))}</li>`;
      }
      return `<p>${applyBold(trimmed)}</p>`;
    })
    .join('');

  const withLists = html.replace(/(?:<li>.*?<\/li>)+/g, (m) => `<ul>${m}</ul>`);
  return withLists || '<p></p>';
}

export function DateDivider({ label }) {
  return (
    <div className="msg-date">
      <span>{label}</span>
    </div>
  );
}

export function AiBubble({ text, html, children, name = 'AIマネージャー', time, streaming = false }) {
  const raw = text ?? html ?? '';
  const safeHtml = formatSafeChatText(raw);
  return (
    <div className="msg msg--ai">
      <span className="msg-av">M</span>
      <div className="msg-col">
        {name && <span className="msg-name">{name}</span>}
        <div className="msg-line">
          {children ? (
            <div className="bubble bubble--ai">{children}</div>
          ) : (
            <div
              className={`bubble bubble--ai${streaming ? ' bubble--streaming' : ''}`}
              dangerouslySetInnerHTML={{ __html: safeHtml }}
            />
          )}
          {time && <span className="msg-time">{time}</span>}
        </div>
      </div>
    </div>
  );
}

export function UserBubble({ text, time, read = true, wrap = false }) {
  return (
    <div className="msg msg--user">
      <span className="msg-meta">
        {read && <span className="msg-read">既読</span>}
        {time && <span className="msg-time">{time}</span>}
      </span>
      <div className={`bubble bubble--user${wrap ? ' bubble--wrap' : ''}`}>{text}</div>
    </div>
  );
}

export function ChatMenu({ items, onNavigate }) {
  return (
    <div className="chat-menu">
      {items.map((it) => (
        <button
          type="button"
          className="chat-menu-row"
          key={it.route}
          onClick={() => it.route && onNavigate(it.route)}
        >
          <span className="chat-menu-ic">{it.icon}</span>
          <span className="chat-menu-body">
            <span className="chat-menu-t">{it.title}</span>
            <span className="chat-menu-d">{it.desc}</span>
          </span>
          <svg className="chat-menu-chev" viewBox="0 0 8 14" fill="none" aria-hidden="true">
            <path d="M1 1l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      ))}
    </div>
  );
}

export function Chips({ items, onNavigate }) {
  return (
    <div className="chips">
      {items.map((c, i) => (
        <button
          type="button"
          key={c.route || c.label}
          className={`chip${i === 0 && c.route ? ' primary' : ''}`}
          onClick={() => c.route && onNavigate(c.route)}
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
